module.exports = __webpack_public_path__ + "static/media/very_happy.234d7cfc.png";